import React, { useEffect, useState } from "react";

// components
import { Button, Card, CardBody, CardHeader, Form, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// views
import FormularioFicha from "./FormularioFicha";

// helpers
import { showMessage } from "../../../helpers/message.js";

// api
import formulariovistoria_api from "../../../api/formulariovistoria_api.js";
import usuario_api from "../../../api/usuario_api.js";

export default function FormularioLista() {

  const [showLoading, setshowLoading] = useState(false);

  const [list_table, set_list_table] = useState([]);
  const [rowEdit, set_rowEdit] = useState(null);
  const [showDetail, set_showDetail] = useState(false);
  const [isDisable, set_isDisable] = useState(true);

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    setshowLoading(true);
    formulariovistoria_api.getItem(rowData.formularioVistoria_Id).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_rowEdit(result.data);
        set_showDetail(true);
      }
    });
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
    loadList();
  }

  const loadList = () => {
    setshowLoading(true);
    formulariovistoria_api.getAll().then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  useEffect(() => {
    usuario_api.getFuncionalidadeAcaoLiberada("CadastroFormularios", "Editar").then((result) => { set_isDisable(!result); });

    loadList();
  }, []);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            {!isDisable && <Button color="default" onClick={handleAdd}><i className="fa fa-plus"></i>  Novo Formulário</Button>}
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Formulários de Vistoria</h4>
              </CardHeader>
              <CardBody>
                <Form>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'Identificação', field: 'identificacao' },
                      { title: 'Local de Execução', field: 'localExecucao' },
                      { title: 'Tipo de Resposta', field: 'tipoResposta' },
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{
                      ...table_style,
                      filtering: false,
                      exportButton: true
                    }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      }
                    ]}
                    localization={table_translate}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <FormularioFicha
          item={rowEdit}
          handleReturn={handleReturn}
        />
      }

    </>

  );
}